<template>
    <section class="section puntos-page">
        <h1 class="title is-4 has-text-centered"><font-awesome-icon icon="coins"/> Puntos</h1>
        
        <Panel title="Puntos Gratis" icon="info-circle">
            <div class="panel-block is-block">
                <p>Cada 24 horas despues que leíste tu ultima notificacion de puntos gratis volveras a recibir 100 puntos mas. Asi que es importante abrir las notificaciones.</p>
                <div class="columns is-vcentered is-centered">
                    <div class="column is-1">
                        <figure class="image is-48x48 imageMargin">
                            <img class="is-rounded" src="@/assets/img/btnNotification.png" alt="">
                        </figure>
                    </div>
                    <div class="column is-4">
                        <figure class="image is-300 ">
                            <img class="is-rounded1" src="@/assets/img/notificacionPuntos.png" alt="">
                        </figure>
                    </div>
                </div>
            </div>
        </Panel>

        <Panel title="Enviar puntos" icon="paper-plane">
            <div class="panel-block is-block">
                <p>Quieres ayudar a un amigo con algunos puntos?</p>
                <p>Esto es posible, solo entra a su perfil y encontraras la opcion para enviar</p>
                <figure class="image is-300">
                    <img class="is-rounded1" src="@/assets/img/enviarpuntos.png" alt="">
                </figure>
            </div>
        </Panel>

        <Panel title="Comprar Puntos" icon="dollar-sign">
            <div class="panel-block is-block has-text-centered">
                <div class="select">
                    <select name="paquete" id="" v-model="paquete">
                        <option :value="100" :key="100">$1 USD (3,000 puntos)</option>
                        <option :value="500" :key="500">$5 USD (25,000 puntos)</option>
                        <option :value="1000" :key="1000">$10 USD (70,000 puntos)</option>
                    </select>
                </div>

                <form id="payment-form" @submit.prevent="paySubmit">

                    <div id="card-element" class="control">
                    <!-- Elements will create input elements here -->
                    </div>

                    <!-- We'll put the error messages in this element -->
                    <div id="card-errors" class="has-text-danger" role="alert"></div>

                    <button id="submit" class="button is-info is-fullwidth" :class="{'is-loading': this.paymentLoading}">Comprar</button>
                </form>
                
            </div>
        </Panel>
    </section>
</template>

<script>
    import Panel from '@/components/Panel'
    import { mapState } from 'vuex'
    import Quinielazoservice from  '@/services/QuinielazoService'
    export default {
        components: { Panel },
        name: 'Puntos',
        data() {
            return {
                paquete: 100,
                clientId: null,
                stripe: null,
                card: null,
                paymentLoading: false
            }
        },
        computed: {
            ...mapState('user',['user'])
        },
        mounted() {
            let stripeApi = document.createElement('script')
            stripeApi.setAttribute('src', 'https://js.stripe.com/v3/')
            stripeApi.setAttribute('data-locale','es')
            document.head.appendChild(stripeApi)

            stripeApi.onload = setTimeout(function(){
                this.initStripe()
            }.bind(this), 1000)
        },
        methods: {
            initStripe(){
                console.log('stripe loaded')
                let pkey
                switch (window.location.hostname) {
                    case 'quinielazo.com':
                        pkey = 'pk_live_51H3RQaE12f41oDvc8iWxpTW9XCBDAYm21reorSXqVoOGstof3GiBXiASlcx64QnOTM54WL2X1LdsJb99vHdrsUh100BeCeQebo'
                        break;
                    default:
                        pkey = 'pk_test_51H3RQaE12f41oDvcTiDozMVuBOQ0izdfitBLACjzit03VyGiBCBVGR6s7GMk48ohKOLQJy66gIGYbqQ1GgMDWy7e000FCJJzuy'
                        break;
                }
                                
                this.stripe = window.Stripe(pkey);
                var elements = this.stripe.elements();
                // Set up Stripe.js and Elements to use in checkout form
                var style = {
                    base: {
                        color: "#32325d",
                    }
                };

                this.card = elements.create("card", { style: style });
                this.card.mount("#card-element");
                this.card.on('change', ({error}) => {
                const displayError = document.getElementById('card-errors');
                if (error) {
                    displayError.textContent = error.message;
                } else {
                    displayError.textContent = '';
                }
                });
            },
            getClient(){
                return Quinielazoservice.getStripeClient({amount: this.paquete})
            },
            paySubmit(){
                this.getClient()
                .then(resp => {
                    
                    this.paymentLoading = true
                    this.stripe.confirmCardPayment(resp.data.client_secret, {
                        payment_method: {
                            card: this.card,
                            billing_details: {
                                name: this.user.user.id,
                                email: this.user.user.email
                            }
                        }
                    }).then(function(result) {
                        if (result.error) {
                            // Show error to your customer (e.g., insufficient funds)
                            this.$store.dispatch('notification/add', {
                                type: 'error',
                                message: result.error.message
                            })
                            const displayError = document.getElementById('card-errors');
                            displayError.textContent = result.error.message
                        } else {
                            // The payment has been processed!
                            if (result.paymentIntent.status === 'succeeded') {
                                // Show a success message to your customer
                                // There's a risk of the customer closing the window before callback
                                // execution. Set up a webhook or plugin to listen for the
                                // payment_intent.succeeded event that handles any business critical
                                // post-payment actions.
                                this.$store.dispatch('notification/add', {
                                    type: 'success',
                                    message: "Tu compra de puntos fue realizada existosamente",
                                    timeout: 10000
                                })
                            }
                        }
                        this.paymentLoading = false
                    }.bind(this));    
                })
            }  
        }
    }
</script>

<style lang="css" scoped>
.puntos-page{
    padding: 1rem 1rem;
}
.is-rounded1{
    border-radius: .4em;
}
.is-300{
    width: 100%;
    max-width: 300px;
    margin: 1em auto 1em auto;
}
.imageMargin{
    margin: 0 auto;
}
#card-element{
    background-color: white;
    padding: 1em;
    border-radius: .5em;
}
#payment-form{
    max-width: 400px;
    margin: 0 auto;
}
#payment-form button{
    margin-top: .8em;
}
select{ border-radius: .5em; width: 100%;}
.select{margin-bottom: .5em; max-width: 400px; width: 100%; }
</style>